import { configureScope } from '@sentry/react'

import { fullName } from '@/travelsuit/users.utils'
import { User } from '@/types/user'

export function setUserForErrorTracking(user: User) {
	configureScope((scope) => {
		scope.setUser({
			id: user.id!.toString(),
			email: user.email!,
			username: fullName(user),
		})
	})
}
